import { useCallback, useEffect, useRef, useState } from 'react';

/* Sommerfest — Team-Scan, idiotensicher (Brief 11.09.2026).
   Route /fest/scan?wer=Gera&station=challenge — ein Link je Trainer, kein
   Login: Kamera läuft, QR der Festkarte davorhalten, Name erscheint, ein
   Tipp, Kamera läuft weiter. Der volle Scanner mit Kurswahl bleibt unter
   /fest/scan-voll (Login). API: routes/fest_scan.py. */

const API = process.env.REACT_APP_BACKEND_URL || '';

const STATIONEN = {
  challenge: { titel: 'Challenge', dabei: 'Challenge gemacht', ergebnis: true },
  kinder: { titel: 'Kinder-Training', dabei: 'Hat mitgemacht' },
  erwachsene: { titel: 'Erwachsenen-Training', dabei: 'Hat mitgemacht' },
  frauen: { titel: 'Frauentraining', dabei: 'Hat mitgemacht' },
  stand: { titel: 'Beratungsstand' },
};
const INTERESSE = { kinder: 'Kinder', frauen: 'Frauen', erwachsene: 'Erwachsene', nur_verlosung: 'nur Verlosung' };
// Gymfights 26.09.: nur VIP wird am Fest kassiert, Sitz/Steh sind Reservierungen
// (10 € Mindestverzehr am Einlass). Kontingent kommt vom Server (tickets_frei).
const TICKETS = [
  { key: 'vip', label: 'VIP', preis: 35, max: 10 },
  { key: 'sitz', label: 'Sitzplatz', preis: 10, max: 40 },
  { key: 'steh', label: 'Stehplatz', preis: 0, max: 30 },
];
const TABS = [['kinder', 'Kinder'], ['erwachsene', 'Erwachsene'], ['frauen', 'Frauen'], ['stand', 'Stand']];

const CSS = `
.fs2{min-height:100vh;background:#000;color:#fff;font:18px/1.4 -apple-system,system-ui,sans-serif;padding:20px 16px 40px;max-width:520px;margin:0 auto}
.fs2 h1{font-size:20px;font-weight:600;margin:0 0 20px;color:#9a9a9a}
.fs2 h1 b{color:#fff}
.fs2 video{width:100%;border-radius:16px;background:#111;aspect-ratio:1;object-fit:cover}
.fs2 .btn{display:block;width:100%;padding:22px;font-size:21px;font-weight:700;border-radius:14px;border:0;background:#f5821f;color:#000;margin-top:12px}
.fs2 .btn.ghost{background:#1a1a1a;color:#fff;border:2px solid #333;font-weight:600}
.fs2 .btn:disabled{opacity:.4}
.fs2 input{width:100%;padding:18px;font-size:22px;border-radius:14px;border:2px solid #333;background:#111;color:#fff;margin-top:12px;text-align:center}
.fs2 input:focus{outline:none;border-color:#f5821f}
.fs2 .name{font-size:36px;font-weight:800;line-height:1.1;color:#f5821f;margin:24px 0 4px}
.fs2 .meta{color:#9a9a9a;margin-bottom:8px}
.fs2 .ok{background:#0f2d18;border:2px solid #2ecc71;padding:20px;border-radius:14px;font-weight:700;font-size:22px;text-align:center;margin-bottom:16px}
.fs2 .err{background:#2d0f0f;border:2px solid #e74c3c;padding:16px;border-radius:14px;margin-bottom:16px}
.fs2 .los{margin-top:14px;color:#9a9a9a;font-size:15px;text-align:center}
.fs2 .losrow{display:flex;gap:8px}
.fs2 .losrow input{margin:0;text-align:left;font-size:18px;padding:14px}
.fs2 .losrow .btn{width:auto;margin:0;padding:14px 18px;font-size:17px}
.fs2 .tabs{display:flex;gap:8px;margin-bottom:14px}
.fs2 .tab{flex:1;padding:16px 4px;font-size:17px;font-weight:600;border-radius:12px;border:2px solid #333;background:#111;color:#fff}
.fs2 .tab.on{border-color:#f5821f;background:#2a1706;color:#f5821f}
`;

function codeAusText(text) {
  const t = String(text || '').trim();
  const m = t.match(/[?&]c=([A-Za-z0-9_-]+)/) || t.match(/\/fest\/k\/([A-Za-z0-9_-]+)/) || t.match(/\/fest\/([A-Za-z0-9_-]{6,12})(?:[?#]|$)/);
  if (m) return m[1];
  return /^[A-Za-z0-9_-]{6,12}$/.test(t) ? t : null;
}

export default function FestScanEinfachPage() {
  const params = new URLSearchParams(window.location.search);
  const wer = (params.get('wer') || 'Team').slice(0, 40);
  // station=multi: vier Tabs oben (Philip/Cagla/Elvan wechseln die Station selbst)
  const multi = params.get('station') === 'multi';
  const [stationKey, setStationKey] = useState(multi ? 'kinder' : (STATIONEN[params.get('station')] ? params.get('station') : 'stand'));
  const station = STATIONEN[stationKey];

  const [gast, setGast] = useState(null);
  const [ergebnis, setErgebnis] = useState('');
  const [los, setLos] = useState('');
  const [ok, setOk] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const videoRef = useRef(null);
  const streamRef = useRef(null);
  const rafRef = useRef(null);

  const stopScan = useCallback(() => {
    cancelAnimationFrame(rafRef.current);
    streamRef.current?.getTracks().forEach((t) => t.stop());
    streamRef.current = null;
  }, []);

  const ladeGast = useCallback(async (text) => {
    const token = codeAusText(text);
    if (!token) { setErr('Das ist keine Festkarte. Nochmal scannen.'); return; }
    stopScan();
    try {
      const r = await fetch(`${API}/api/public/fest/gast/${encodeURIComponent(token)}`);
      if (!r.ok) { setErr(r.status === 404 ? 'Das ist keine Festkarte. Nochmal scannen.' : 'Karte konnte nicht geladen werden.'); setGast(null); return; }
      setErr(''); setOk('');
      setGast(await r.json());
    } catch { setErr('Kein Netz — nochmal versuchen.'); setGast(null); }
  }, [stopScan]);

  const startScan = useCallback(async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment' } });
      streamRef.current = stream;
      const v = videoRef.current;
      if (!v) return;
      v.srcObject = stream;
      v.setAttribute('playsinline', true);
      await v.play();
      const { default: jsQR } = await import('jsqr');
      const c = document.createElement('canvas');
      const ctx = c.getContext('2d', { willReadFrequently: true });
      const tick = () => {
        if (!streamRef.current) return;
        if (v.readyState === v.HAVE_ENOUGH_DATA) {
          c.width = v.videoWidth; c.height = v.videoHeight;
          ctx.drawImage(v, 0, 0);
          const img = ctx.getImageData(0, 0, c.width, c.height);
          const code = jsQR(img.data, img.width, img.height, { inversionAttempts: 'dontInvert' });
          if (code?.data && codeAusText(code.data)) { ladeGast(code.data); return; }
        }
        rafRef.current = requestAnimationFrame(tick);
      };
      rafRef.current = requestAnimationFrame(tick);
    } catch {
      setErr('Kamera ist gesperrt. In den Browser-Einstellungen Kamera für crm.p1-pforzheim.de erlauben — oder Losnummer unten eintippen.');
    }
  }, [ladeGast]);

  // Kamera läuft dauerhaft, solange kein Gast geladen ist
  useEffect(() => {
    if (!gast) startScan();
    return stopScan;
  }, [gast, startScan, stopScan]);

  // Offline-Shell wie beim vollen Scanner
  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;
    navigator.serviceWorker.register('/fest/sw.js', { scope: '/fest/' }).catch(() => {});
  }, []);

  const perLos = async () => {
    // Fallback ohne Kamera: Losnummer -> Karte (öffentlicher Weg gibt es nicht, daher über den Gast-Code-Link)
    setErr('Ohne QR bitte den Gast zum Beratungsstand schicken — dort wird per Name gesucht.');
    setLos('');
  };

  const speichern = async (typ, ticket = null) => {
    setBusy(true); setErr('');
    try {
      const r = await fetch(`${API}/api/public/fest/aktion`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token: gast.token, typ, station: stationKey,
                               wert: typ === 'challenge' ? (ergebnis || null) : ticket, erfasst_von: wer }),
      });
      if (r.status === 409) { setErr('Diese Ticketart ist ausverkauft.'); setBusy(false); return; }
      if (!r.ok) { setErr('Nicht gespeichert – nochmal tippen.'); setBusy(false); return; }
      const d = await r.json();
      const tk = TICKETS.find((t) => t.key === (d.kategorie || ticket));
      const text = {
        dabei: `${gast.vorname} – ${station.dabei}`,
        challenge: `${gast.vorname} – Challenge ${d.challenges || ''}${ergebnis ? ` (${ergebnis})` : ''}${d.verlosung_erreicht ? ' · im Lostopf' : ''}`,
        probetraining: d.schon ? `${gast.vorname} – war schon vereinbart` : `${gast.vorname} – Probetraining vereinbart, ${d.aufgabe_fuer || 'Cagla'} meldet sich`,
        gymfights: d.schon ? `${gast.vorname} – Ticket war schon vermerkt (${tk?.label || ''})`
          : tk?.key === 'vip' ? `${gast.vorname} – VIP gebucht, 35 € jetzt kassieren`
          : `${gast.vorname} – ${tk?.label || 'Ticket'} reserviert${tk?.preis ? ', 10 € Mindestverzehr am 26.09.' : ''}`,
      }[typ];
      setOk(text);
      setGast(null); setErgebnis('');
      setTimeout(() => setOk(''), 4000);
    } catch { setErr('Kein Netz – nochmal tippen.'); }
    setBusy(false);
  };

  return (
    <div className="fs2" data-testid="fest-scan-einfach"><style>{CSS}</style>
      <h1><b>{station.titel}</b> · {wer}</h1>
      {ok && <div className="ok">✓ {ok}</div>}
      {err && <div className="err">{err}</div>}

      {multi && !gast && (
        <div className="tabs" data-testid="stations-tabs">
          {TABS.map(([k, label]) => (
            <button key={k} className={'tab' + (stationKey === k ? ' on' : '')} onClick={() => setStationKey(k)}>{label}</button>
          ))}
        </div>
      )}

      {!gast && (
        <>
          <video ref={videoRef} muted />
          <div className="los">QR vom Gast vor die Kamera halten — der Name erscheint von selbst.</div>
          <div className="losrow" style={{ marginTop: 10 }}>
            <input placeholder="Kein QR? Karten-Code eintippen" value={los} onChange={(e) => setLos(e.target.value)}
                   onKeyDown={(e) => e.key === 'Enter' && los && ladeGast(los)} />
            <button className="btn ghost" onClick={() => (los ? ladeGast(los) : perLos())}>Laden</button>
          </div>
        </>
      )}

      {gast && (
        <>
          <div className="name">{gast.vorname} {gast.nachname}</div>
          <div className="meta">
            Los #{gast.losnummer} · {gast.interessen?.length ? gast.interessen.map((i) => INTERESSE[i] || i).join(', ') : 'kein Interesse angegeben'}
            {gast.kinder?.length ? ` · Kinder: ${gast.kinder.join(', ')} J.` : ''}
            {gast.challenges ? ` · ${gast.challenges} Challenge(s)` : ''}
            {gast.probetraining ? ' · Probetraining schon vereinbart' : ''}
            {gast.gymfights ? ' · Gymfights-Ticket vermerkt' : ''}
          </div>

          {station.ergebnis && (
            <input inputMode="numeric" placeholder="Ergebnis (optional)" value={ergebnis} onChange={(e) => setErgebnis(e.target.value)} />
          )}
          {station.dabei && (
            <button className="btn" disabled={busy} onClick={() => speichern(station.ergebnis ? 'challenge' : 'dabei')} data-testid="btn-dabei">
              {station.dabei}
            </button>
          )}
          <button className="btn" disabled={busy || gast.probetraining} onClick={() => speichern('probetraining')} data-testid="btn-probetraining">
            Probetraining vereinbaren
          </button>
          {stationKey === 'stand' && (
            <>
              <div className="meta" style={{ marginTop: 16 }}>
                Gymfights 26.09. – nur VIP wird heute kassiert
                {gast.gymfights ? ` · schon vermerkt: ${TICKETS.find((t) => t.key === gast.gymfights_kategorie)?.label || 'Ticket'}` : ''}
              </div>
              {TICKETS.map((t) => {
                const frei = gast.tickets_frei?.[t.key] ?? t.max;
                return (
                  <button key={t.key} className="btn ghost" disabled={busy || gast.gymfights || frei <= 0}
                          onClick={() => speichern('gymfights', t.key)} data-testid={`btn-ticket-${t.key}`}>
                    {t.key === 'vip' ? 'VIP · 35 €' : `${t.label} · ${t.preis ? '10 € Verzehr am Abend' : 'kostenlos'}`} · {frei > 0 ? `${frei} frei` : 'ausverkauft'}
                  </button>
                );
              })}
            </>
          )}
          <button className="btn ghost" onClick={() => setGast(null)}>Abbrechen</button>
        </>
      )}
    </div>
  );
}
